import { type ComponentType } from 'react'
import * as LC from './lazyComponents'
import { type MainLayoutCustomStylesWithStatesProps } from '@applyft-web/ui-components'

const CHECKOUT_IMAGES = [
  '/assets/images/checkout/card-brands/amex.png',
  '/assets/images/checkout/card-brands/apple.png',
  '/assets/images/checkout/card-brands/discover.png',
  '/assets/images/checkout/card-brands/google.png',
  '/assets/images/checkout/card-brands/maestro.png',
  '/assets/images/checkout/card-brands/mastercard.png',
  '/assets/images/checkout/card-brands/paypal.png',
  '/assets/images/checkout/card-brands/visa.png',
  '/assets/images/checkout/wallets/applePay.png',
  '/assets/images/checkout/wallets/applePay-small.png',
  '/assets/images/checkout/wallets/googlePay.png',
  '/assets/images/checkout/wallets/googlePay-small.png',
  '/assets/images/checkout/wallets/paypal.png',
  '/assets/images/checkout/wallets/paypal-small.png',
  '/assets/images/checkout/wallets/blik.png',
  '/assets/images/checkout/wallets/amazonPay.png',
  '/assets/images/checkout/money-back.svg',
]

export interface CheckoutPageConfig {
  readonly component: LC.LazyComponentWithPreload<ComponentType<any>>
  readonly withFooter: boolean
  readonly images: string[]
  readonly wrapperProps: {
    readonly customStyles: MainLayoutCustomStylesWithStatesProps
  }
  readonly componentProps?: Record<string, unknown>
}

const CHECKOUT_PAGE_BASE: Omit<CheckoutPageConfig, 'componentProps'> = {
  component: LC.Checkout,
  withFooter: true,
  images: CHECKOUT_IMAGES,
  wrapperProps: {
    customStyles: {
      default: 'text-align:inherit;',
    },
  },
}

export const createCheckoutPageConfig = (
  componentProps?: CheckoutPageConfig['componentProps'],
): CheckoutPageConfig => ({
  ...CHECKOUT_PAGE_BASE,
  componentProps,
})
